var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-card",
    {
      attrs: { title: "Error", "header-tag": "header", "footer-tag": "footer" },
      scopedSlots: _vm._u([
        {
          key: "header",
          fn: function () {
            return [
              _c("h6", { staticClass: "mb-0" }, [_vm._v("Ooops... error !")]),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c("b-card-text", [
        _vm.error && _vm.error.statusCode === 404
          ? _c("div", [
              _vm._v(
                "\n      Halaman yang Anda cari tidak ditemukan (404).\n    "
              ),
            ])
          : _c("div", [
              _vm._v(
                "\n      Mohon maaf, telah terjadi kesalahan pada sistem.\n    "
              ),
            ]),
      ]),
      _vm._v(" "),
      _c(
        "b-button",
        { attrs: { variant: "primary" }, on: { click: _vm.goBack } },
        [_vm._v("Kembali")]
      ),
      _vm._v(" "),
      _vm.isAuthenticated
        ? _c(
            "b-button",
            {
              staticClass: "ml-2",
              attrs: { variant: "info" },
              on: { click: _vm.goToDashboard },
            },
            [_vm._v("Ke Dashboard")]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }